export default __webpack_public_path__ + "static/media/cutellama.e0ee1838.jpg";